/**
 * Generic javascript goes here
 * TODO: Not es6 :(
 */
var s,
  Nbia = {
    /**
     * General settings to be used
     */
    settings: {
      equalHeight: {
        parentSelector: '.js-equal-height',
        childSelector: '.js-equal-height__child a',
      },
    },

    /**
     * Boot up
     */
    init: function() {
      s = this.settings;
      this.bindUIActions();
      this.equalHeight();
    },

    /**
     * Anything that requires binding to interactions (click, hover etc);
     */
    bindUIActions: function() {},

    /**
     * Any additional methods
     * Call as either part of init, within a UI action, or something else
     */

    /**
     * Look for anything with a class name, make them the same height
     * TODO: Responsive changes?
     */
    equalHeight: function() {
      var selector = this.settings.equalHeight.parentSelector;
      var childSelector = this.settings.equalHeight.childSelector;
      if (
        document.querySelector(selector) &&
        document.querySelectorAll(selector).length >= 1
      ) {
        var blocks = document.querySelectorAll(selector);
        for (var i = 0; i < blocks.length; i++) {
          var block = blocks[i];
          var blockHeight = 0;
          var children = block.querySelectorAll(childSelector);
          if (children && children.length > 1) {
            for (var x = 0; x < children.length; x++) {
              var child = children[x];
              if (child.offsetHeight > blockHeight) {
                blockHeight = child.offsetHeight;
              }
            }
            for (var x = 0; x < children.length; x++) {
              var child = children[x];
              child.style.height = blockHeight + 'px';
            }
          }
        }
      }
    },
  };

/**
 * Load once the page is ready
 */
(function() {
  Nbia.init();
})();
